import { call, put, select } from 'redux-saga/effects';
import { improvementAreaSelectors } from 'store/data/improvementArea';
import { suggestionActions } from 'store/data/suggestion';
import { sagaWrapper } from 'store/helpers';
import { ActionType } from 'typesafe-actions';

import * as improvementsActions from './actions';
import * as constants from './constants';
import * as improvementsSelectors from './selectors';

// Inserts a temporary placeholder suggestion so the user can fill in the form
// before it is persisted. Replaces any existing mock to avoid duplicates.
// The mock is stamped with the lowest-sortOrder improvement area when one
// exists; the user can change it in the detail editor before saving.
export function* startCreateMockSuggestionSaga(
  action: ActionType<typeof improvementsActions.startCreateMockSuggestion>,
) {
  function* saga() {
    const defaultImprovementAreaId: ReturnType<
      typeof improvementAreaSelectors.defaultImprovementAreaId
    > = yield select(improvementAreaSelectors.defaultImprovementAreaId);

    const mockSuggestion: Data.Suggestion = {
      id: constants.MOCKED_SUGGETION_ID,
      improvementAreaId: defaultImprovementAreaId,
      reporter: '',
      name: 'New suggestion',
      problemStatement: '',
      solutionProposal: '',
      status: 'NEW',
      actionIds: [],
      created: new Date().getTime(),
      imageUris: [],
    };

    const hasMockSuggestion: ReturnType<
      typeof improvementsSelectors.hasMockedSuggestion
    > = yield select(improvementsSelectors.hasMockedSuggestion);

    // Remove stale mock before adding the fresh one
    if (hasMockSuggestion) {
      yield put(suggestionActions.remove(mockSuggestion.id));
    }

    yield put(suggestionActions.add(mockSuggestion));
    yield put(improvementsActions.setSelectedSuggestionId(mockSuggestion.id));
  }

  yield call(sagaWrapper, { saga, type: action.type });
}
